export interface FetchableSuccess<T> {
  data: T;
  status: "ready";
}

export interface FetchableLoading {
  status: "loading";
}

export interface FetchableStart {
  status: "empty";
}

export interface FetchableError {
  status: "error";
  err: Error;
}

export type Fetchable<T> =
  | FetchableSuccess<T>
  | FetchableError
  | FetchableStart
  | FetchableLoading;

export const EmptyFetchable: FetchableStart = {
  status: "empty",
};

export function isFetchableDone<T>(
  f: Fetchable<T>
): f is FetchableError | FetchableSuccess<T> {
  return f.status === "error" || f.status === "ready";
}

export function isFetchableSuccess<T>(
  f: Fetchable<T>
): f is FetchableSuccess<T> {
  return f.status === "ready";
}

export function isFetchableToLoad<T>(
  f: Fetchable<T>
): f is FetchableError | FetchableStart {
  return f.status === "error" || f.status === "empty";
}

export function isFetchableError<T>(f: Fetchable<T>): f is FetchableError {
  return f.status === "error";
}